export const ContainerTypeComponentIdentifier = 'containertype';
